import script from "./AutoAddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoAddModal.vue?vue&type=script&setup=true&lang=js"

import "./AutoAddModal.vue?vue&type=style&index=0&id=72eab5c3&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72eab5c3"]])

export default __exports__